import React from 'react';
import BlogConainer from 'containers/BlogConainer';

export default function BlogPage() {
  return <BlogConainer />;
}
